import React from "react";
import { css } from "@emotion/react";
import theme from "@styles/theme";
import { useTranslation } from "react-i18next";

const VideoFallbackCard: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div css={styles.container}>
      <div css={styles.content}>
        <strong>{t("issue.videoAttachment")}</strong>
        <span css={styles.name}>{t("issue.noPreviewAvailable")}</span>
      </div>
    </div>
  );
};

const styles = {
  container: css({
    display: "flex",
    width: "100%",
    height: "100%",
    padding: theme.sizing.scale300,
    boxSizing: "border-box",
  }),
  content: css({
    flex: 1,
    display: "grid",
    placeItems: "center",
    textAlign: "center",
    gap: theme.sizing.scale200,
    padding: theme.sizing.scale600,
    backgroundColor: theme.colors.mono100,
    border: `1px solid ${theme.colors.mono200}`,
    borderRadius: theme.borders.radius400,
    width: "100%",
    height: "100%",
  }),
  name: css({
    color: theme.colors.mono700,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
};

export default VideoFallbackCard;
